import { Component, Input } from '@angular/core';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'wo-icon-field',
  templateUrl: './icon-field.component.html',
  styleUrls: [ './icon-field.component.scss' ],
  standalone: true,
  imports: [ IconComponent ],
})
export class IconFieldComponent {
  @Input({ required: true }) public icon!: IconName;
}
